import axios from 'axios';
import authHeader from './../auth-header';
const API_URL = process.env.VUE_APP_API_URL;

class PrescriptionService {
    fetchPendingPrescriptions(doctor_id){
        return axios.get(`${API_URL}/doctors/${doctor_id}/checkupprescriptions/pending`, {headers: authHeader()});
    }

    createPrescriptionPDF(checkupprescription_id, prescription){
        return axios.put(`${API_URL}/checkupprescriptions/${checkupprescription_id}/pdf`, prescription, {headers: authHeader()})
    }
}

export default new PrescriptionService();
